import { render, staticRenderFns } from "./FhGanaderiaMenuSearch.vue?vue&type=template&id=1def13d8&scoped=true&"
import script from "./FhGanaderiaMenuSearch.vue?vue&type=script&lang=js&"
export * from "./FhGanaderiaMenuSearch.vue?vue&type=script&lang=js&"
import style0 from "./FhGanaderiaMenuSearch.vue?vue&type=style&index=0&id=1def13d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def13d8",
  null
  
)

export default component.exports